<template>
<div>
  <h3 class="mb-3">{{data.title}}</h3>
  <apex-chart  :options="options" :series="series" :height="400"></apex-chart>
</div>
</template>

<script>
  import apexChart from "vue-apexcharts";
  export default {
    name: "line-chart",
    components: {
      apexChart
    },
    props: {
      data: {
        type: Object,
        default: ()=> {
          return {}
        }
      }
    },
    data () {
      return {
        options: {
          chart: {
            id: this.data.title,
            height: 300,
            width: 400,
          },
          markers: {
            size: 5,
            colors: undefined,
            strokeColors: '#fff',
            strokeWidth: 2,
            strokeOpacity: 0.9,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [],
            shape: "circle",
            radius: 2,
            offsetX: 0,
            offsetY: 0,
            onClick: undefined,
            onDblClick: undefined,
            hover: {
              size: undefined,
              sizeOffset: 3
            }
          },
          stroke: {
            width: [4, 4, 4]
          },
          xaxis: {
            type: this.data.xaxisType,
            title:{
              text: ''
            }
          },
          yaxis: {
            title: {
              text: this.data.yaxisLabel
            }
          }
        },
        series: [

        ]
      }
    },
    mounted() {
      this.updateGraph()
    },
    methods: {
      updateGraph() {
        this.series = []
        for (let j = 0; j < this.data.data.length; j++) {
          let name = this.data.data[j].name
          let data = []
          for (let i = 0; i < this.data.data[j].data.length; i++) {
            data.push({
              x: this.data.data[j].data[i].x,
              y: this.data.data[j].data[i].y
            })
          }
          this.series.push({
            name: name,
            data: data,
            type: 'line'
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
